module.exports = __webpack_public_path__ + "media/L'Inconnu-se-Livre-Virginie-Goevelinger-04.06.2014.1f9a7149.mp3";